import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { connectApp, AppProp } from '../../reducers'
import { isLogged } from '../../reducers/auth/session'
import { fetchSession, isTokenExpired } from '../../actions/auth/session'
import { getToken } from '../../utils/fetchApi'
import Wrapper from '../Wrapper/Wrapper'
import { useTranslation } from 'react-i18next'
import ExpiredSessionDialog from '../Auth/ExpiredSesionDialog';

const AuthWrapper: React.FC<AppProp<'session'>> = ({ session, ...rest }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation('menu')
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (token && isTokenExpired(token)) {
      setTokenExpired(true); // solo mostrar modal, no hacer logout inmedia

    } else if (token && !isLogged(session)) {
      dispatch(fetchSession(history, location, t('home')))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, []);

  return (
    <>
      {tokenExpired && (
        <ExpiredSessionDialog forceShow={true} />
      )}
      <Wrapper show={isLogged(session)} redirect={!getToken()} {...rest} />
    </>
  )

}

export default connectApp('session')(AuthWrapper)